import { DialogContent, Grid, Switch } from '@mui/material';
import { FC, useEffect, useMemo, useState } from 'react';
import { Cell } from 'react-table';
import { IJobFieldSettings, IJobFieldSettingsType } from 'wisestep-api';
import { WsDialog, WsTypography, WsTypoVariants, WsButton, WsDataTable } from 'wisestep-base';

import { HeaderBox } from '../components/HeaderBox';
export interface CustomizeJobTypeDialogProps {
  openDialog: boolean;
  closeDialog(): void;
  onChangeHandler: (data: IJobFieldSettingsType) => void;
  modifiedData?: Omit<
    IJobFieldSettings,
    'id' | 'workspaceId' | 'createdBy' | 'createdOn' | 'modifiedBy' | 'modifiedOn'
  >;
}
const CustomizeJobTypeDialog: FC<CustomizeJobTypeDialogProps> = ({
  openDialog,
  onChangeHandler,
  closeDialog,
  modifiedData,
}) => {
  const defaultData = {
    mandatory: true,
    hide: false,
    disabled: false,
    availableFields: [
      'Permanent',
      'Contract',
      'Temporary',
      'Internship',
      'Freelance',
      'None',
      'PermanentAndContract',
      'ContractToHireW2',
      'ContractW2',
      'ContractIndependent',
      'ContractToHireIndependent',
      'ContractCorpToCorp',
      'ContractToHireCorpToCorp',
      'PartTime',
    ],
    selectedFields: ['Permanent', 'Contract', 'Temporary', 'None', 'Internship', 'Freelance'],
    label: 'Job Type',
    selectedField: '',
  };
  const [jobTypeData, setJobTypeData] = useState<IJobFieldSettingsType>(defaultData);

  useEffect(() => {
    if (modifiedData?.jobType) {
      const jobsTypeFormDefaultValues = modifiedData?.jobType;
      setJobTypeData({ ...jobsTypeFormDefaultValues });
    }
  }, [modifiedData?.jobType]);

  const onChangeHandlerJobType = (data, selectedField) => {
    if (data) {
      const payload: IJobFieldSettingsType = data;
      const assetIndex = payload?.selectedFields.indexOf(selectedField);
      if (assetIndex >= 0) payload?.selectedFields.splice(assetIndex, 1);
      else payload?.selectedFields.push(selectedField);
      return { ...payload };
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Job Type',
        accessor: 'name',
      },
      {
        Header: '',
        accessor: 'jobTypeList',
        Cell: (cell: Cell) => (
          <Switch
            checked={
              jobTypeData &&
              jobTypeData.selectedFields.indexOf(jobTypeData.availableFields[cell?.row.index]) >= 0
            }
            onChange={() =>
              onChangeHandler(
                onChangeHandlerJobType(
                  jobTypeData,
                  jobTypeData?.availableFields[cell?.row.index]
                ) as IJobFieldSettingsType
              )
            }
          />
        ),
      },
    ],
    [jobTypeData, onChangeHandler]
  );

  const configuredTeamsData = useMemo(
    () =>
      jobTypeData &&
      jobTypeData.availableFields
        ?.map((list) => ({
          name: list,
        }))
        .filter((i) => i.name != 'None'),
    [jobTypeData]
  );

  return (
    <WsDialog openDialog={openDialog} size="small">
      <DialogContent>
        <HeaderBox>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>Add/Edit Job Type</WsTypography>
          <WsButton onClick={() => closeDialog()}>Close</WsButton>
        </HeaderBox>

        <Grid container direction="column" xs={12} mt={2}>
          <WsDataTable columns={columns} data={configuredTeamsData ?? []} />
        </Grid>
      </DialogContent>
    </WsDialog>
  );
};
export default CustomizeJobTypeDialog;
